// Module
var code = "<h2 id=\"order-program-materials\">Order Program Materials</h2> <p>Access the Online Request Form for Direct Loan or Direct PLUS Loan Program Materials for Schools.</p> ";
// Exports
export default code;